import { render, staticRenderFns } from "./DeleteSingleGroup.vue?vue&type=template&id=c4e8cf0a&"
import script from "./DeleteSingleGroup.vue?vue&type=script&lang=js&"
export * from "./DeleteSingleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports